import {
  NotificationStrategy,
  markAsAccepted,
  markAsRejected,
} from '../../../../shared/services/notification/workflow';
import { resolveMeToAvNewComponentDecision } from '../../../npi-steering/services/resolveMeToAvNewComponentDecision';
import { finalizeNotificationAction } from './notificationStrategyFinalize';

async function handleAccept({ item }: Parameters<NotificationStrategy['accept']>[0]) {
  const result = await resolveMeToAvNewComponentDecision({
    item,
    decision: 'ACCEPT',
  });

  if (!result?.handled) {
    throw new Error('ME_TO_AV_NEW_COMPONENT decision was not handled');
  }

  await markAsAccepted(item.userNotificationId, item.status);
  await finalizeNotificationAction({
    item,
    strategyName: 'meToAvNewComponentStrategy',
    action: 'accept',
  });
}

async function handleReject({ item }: Parameters<NotificationStrategy['reject']>[0]) {
  await markAsRejected(item.userNotificationId, item.status);
  await finalizeNotificationAction({
    item,
    strategyName: 'meToAvNewComponentStrategy',
    action: 'reject',
  });
}

export const meToAvNewComponentStrategy: NotificationStrategy = {
  accept: handleAccept,
  reject: handleReject,
};
